import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { HttpError } from "../httpError";
import { groupThemeKey } from "../../constants";
import { ThemeProps } from "../../models/theme";

// The theme route's own path segment for a subsidiary. Named here because
// getCorporateType maps a SCOPE to it, and a caller holding only a subsidiary
// id has no scope to map -- the platform front door is one.
export const SUBSIDIARY_THEME_SEGMENT = "corporate-subsidiary";

// The request itself, so the URL and the client live in one place. An
// imperative caller -- resolving a school on a click rather than on render --
// pairs this with groupThemeKey instead of rebuilding the path by hand, which
// is how the seam stays the only thing that knows the route's shape.
export const groupThemeRequest = (
  id: string | number,
  groupType: string,
  authorisation: string
) =>
  httpClient(`theme/${id}/${groupType}`, { authorisation }).get<ThemeProps>();

const useQueryGroupTheme = ({
  id,
  groupType,
  enable = true,
  authorisation = "",
}: {
  id: string | number;
  groupType: string;
  enable?: boolean;
  authorisation: string;
}) => {
  return useQuery<ThemeProps, HttpError>(
    groupThemeKey(groupType, id),
    () => groupThemeRequest(id, groupType, authorisation),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled: enable,
    }
  );
};

export default useQueryGroupTheme;
